import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { AuthContext } from '../contexts/AuthContext';
import { clearPostAuthReturn, rememberReturnToParam } from '../utils/onboardingHandoff';

/**
 * #1390 — conventional auth entry paths land in the real web auth flow.
 * Welcome owns the Login modal on `/`; preserve the query string so OTP /
 * email deep links (Login reads window.location.search) still work.
 * A validated `returnTo` is stored for postAuthDestination (#2637).
 * An existing session with that return goes straight there.
 */
const AuthEntryRedirect = () => {
  const location = useLocation();
  const auth = useContext(AuthContext);
  const returnTo = rememberReturnToParam(location.search);

  if (auth?.loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (auth?.user && auth?.token && returnTo) {
    // The navigation consumes the return. Leave it stored and a later
    // sign-in in this tab would send the person to /account again.
    clearPostAuthReturn();
    return <Navigate to={returnTo} replace />;
  }

  return (
    <Navigate
      to={{ pathname: '/', search: location.search }}
      state={{ openAuth: true }}
      replace
    />
  );
};

export default AuthEntryRedirect;
